// Imports
import React, { useState, useEffect } from 'react';
// Styles
import '../styles/Lottery.css';
// Services
const Routes = require("./../services/routes.js");

function Lottery() {
  // State variables
  const [tickets, setTickets] = useState([]);
  const [blockNumber, setBlockNumber] = useState('');
  const [ticketString, setTicketString] = useState('');
  const [betAmount, setBetAmount] = useState('');
  const [isJackpot, setIsJackpot] = useState(false);

  useEffect(() => {

    return () => {
    };
  }, []);

  const handleSubmit = async (event) => {
    try{
      event.preventDefault();
      const url = Routes.getAuthLotteryURL() + '/purchase-ticket';
      const origin = window.location.origin;
      console.debug(`Sending message to ${url} with origin ${origin}`);
    
      const response = await fetch(
        url,
        {
          method: 'POST',
          headers: {"content-type": "application/json"},
          credentials: "include",
          body: JSON.stringify({
            blockNumber,
            ticketString,
            betAmount,
            isJackpot,
          })
        }
      );
      const result = await response.json();

      // Failure
      if (!response.ok) {
        console.error(`Failed to fetch purchase ticket: ${response.statusText} Status:${response.status}`);

        // If the response was unauthorized
        if(response.status===401){
          localStorage.removeItem('verified'); // Remove verified
          window.location = `/`; // redirect the page to the home page.
        }

        alert(result.message ? result.message : 'Failed to purchase ticket.');
        return;
      }
      // Check for redirect
      else if (result.redirect){
        window.location = result.url;
        return;
      }
      else if(typeof result.verified !== 'undefined'){
        localStorage.verified = result.verified;
      }

      // Success
      getTickets();
    }
    catch(err){
      console.error(err);
    }
  };
  
  const handleShowTickets = async () => {
    getTickets();
  };
  
  // Function to get the list of tickets
  const getTickets = async () => {
    try{
      const url = Routes.getAuthLotteryURL() + `/get-tickets`;
      const origin = window.location.origin;
      console.debug(`Sending message to ${url} with origin ${origin}`);

      const response = await fetch(
        url,
        {
          method: "GET",
          headers: {"content-type": "application/json"},
          credentials: "include",
        }
      );
      const result = await response.json();

      // Failure
      if (!response.ok){
        console.error(`Failed to fetch get tickets: ${response.statusText} Status:${response.status}`);

        // If the response was unauthorized
        if(response.status===401){
          localStorage.removeItem('verified'); // Remove verified
          window.location = `/`; // redirect the page to the home page.
        }

        alert('Failed to show tickets.');
        return;
      }
      // Redirect
      else if (result.redirect){
        window.location = result.url;
        return;
      }
      else if(typeof result.verified !== 'undefined'){
        localStorage.verified = result.verified;
      }

      // Success
      setTickets(result);
    }
    catch(err){
      console.error(`Failed to fetch tickets: ${err}`);
    }
  };

  return (
    <div className="lottery">
      
      <h1>Account</h1>

      <br/>

      <h1>Purchase Lottery Ticket</h1>
      <form className="purchaseForm" onSubmit={handleSubmit}>
          <label htmlFor="blockNumber">Block Number:</label>
          <input className="blockNumber" name="blockNumber" required
            type="number"
            value={blockNumber}
            onChange={(e) => setBlockNumber(e.target.value)}
          />

          <br/>
          <br/>

          <label htmlFor="ticketString">8 Character String (0-9, a-f):</label>
          <input className="ticketString" name="ticketString" required
            type="text"
            pattern="[0-9a-fA-F]{8}"
            value={ticketString}
            onChange={(e) => setTicketString(e.target.value)}
          />

          <br/>
          <br/>

          <label htmlFor="betAmount">Bet Amount:</label>
          <input className="betAmount" name="betAmount" required
            type="number"
            step="0.0000000001"
            value={betAmount}
            onChange={(e) => setBetAmount(e.target.value)}
          />

          <br/>
          <br/>

          <label htmlFor="isJackpot">Jackpot Game:</label>
          <input className="isJackpot" name="isJackpot"
            type="checkbox"
            checked={isJackpot}
            onChange={(e) => setIsJackpot(e.target.checked)}
          />

          <br/>
          <br/>

          <button type="submit">Purchase Ticket</button>
      </form>

      <h1>Purchased Tickets</h1>
      <button className="showTicketsButton" onClick={handleShowTickets}>Show All Tickets</button>
      <div className="ticketsContainer">
          <table className="ticketsTable">
              <thead>
                  <tr>
                      <th>Block Number</th>
                      <th>Ticket String</th>
                      <th>Timestamp</th>
                      <th>Winning Ticket</th>
                      <th>Status</th>
                      <th>Block Hash</th>
                      <th>Correct Characters</th>
                  </tr>
              </thead>
              <tbody>
                {/* Ticket rows will be inserted here */}
                {tickets.map((ticket, index) => {
                  return (
                    <tr key={index}>
                      <td>{ticket.blocknumber}</td>
                      <td>{ticket.ticketstring}</td>
                      <td>{new Date(ticket.timestamp).toLocaleString()}</td>
                      <td>{ticket.winningticket ? 'Yes' : 'No'}</td>
                      <td>{ticket.status}</td>
                      <td>{ticket.blockhash.substring(0, 8)}</td>
                      <td>{ticket.correctchars}</td>
                    </tr>
                  );
                })}
              </tbody>
          </table>
      </div>
    </div>
  );
}

export default Lottery;
